import api from 'ApiConfig';
const timetableSevice = {
  //Timetable
  createTimetable: async (timetableData) => {
    return api.post('/admin/create-timetable', timetableData);
  },

  getSubjectsAndTeachers: async (userId, standard, division, year) => {
    return api.post('/admin/get-subjects-teachers', {
      userId,
      standard,
      division,
      year,
    });
  },

  getTimetable: async (orgId, standard, division, year) => {
    return api.post('/admin/get-timetable', {
      orgId,
      standard,
      division,
      year,
    });
  },

  deletePeriod: async (periodData) => {
    return api.post('/admin/delete-period', periodData);
  },
  //Lms
  getBatchDetails: async (courseId, selectedBranch) => {
    return api.post('/admin/get-batches-details', { courseId, selectedBranch });
  },

  getBatchesByStructure: async (batchStructureId, selectedBranch) => {
    return api.post('/admin/get-batches-by-structure', {
      batchStructureId,
      selectedBranch,
    });
  },
};

export default timetableSevice;
